export const rentTypes = [
  { text: 'Affordable', value: 'affordable' },
  { text: 'Market', value: 'market' }
];
